/**
 * 图片/静态资源 URL 拼接工具
 * 后端只存相对路径（如 /profile/upload/2024/xxx.png），渲染时统一拼接 VITE_IMAGE_BASE_URL。
 *
 * 规则：
 * - 空值 → 返回 ''
 * - 已是 http(s)/data:/blob: 绝对地址 → 原样返回
 * - 历史数据若误带了旧 API 前缀（如 /ogd），先剥离再拼接
 */
const IMAGE_BASE_URL = (import.meta.env.VITE_IMAGE_BASE_URL || '').replace(/\/$/, '');
const LEGACY_PREFIXES = ['/ogd'];

export function assetUrl(path?: string | null): string {
  if (!path) return '';
  if (/^(https?:|data:|blob:)/i.test(path)) return path;
  let p = path;
  for (const prefix of LEGACY_PREFIXES) {
    if (p.startsWith(prefix + '/')) { p = p.slice(prefix.length); break; }
    if (p === prefix) { p = '/'; break; }
  }
  if (!IMAGE_BASE_URL) return p;
  return IMAGE_BASE_URL + (p.startsWith('/') ? p : '/' + p);
}

export default assetUrl;
